import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';

// Mirrors the main app's apiSlice.js exactly: relative baseUrl (works
// whether this app is proxied in dev or served from its own subdomain in
// production, as long as it shares a registrable domain with the API),
// `credentials: 'include'` so the httpOnly `agencyJwt` cookie is always
// sent, and echoing the non-httpOnly `csrf-token` cookie as a header for
// the shared csrfProtect middleware.
const baseQuery = fetchBaseQuery({
  baseUrl: '/',
  credentials: 'include',
  prepareHeaders: (headers) => {
    const csrfToken = document.cookie
      .split('; ')
      .find((row) => row.startsWith('csrf-token='))
      ?.split('=')[1];

    if (csrfToken) {
      headers.set('X-CSRF-Token', csrfToken);
    }
    return headers;
  },
});

// A 401 here means the agencyJwt cookie is missing/expired/invalid — bounce
// straight back to login rather than letting the screen sit on stale data.
const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result?.error?.status === 401 && window.location.pathname !== '/login') {
    window.location.assign('/login');
  }
  return result;
};

export const apiSlice = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: ['AgencyShift'],
  endpoints: () => ({}),
});
